export var calcularTiempoTranscurrido = function (fecha) {
    var fechaActual = new Date();
    var fechaVisualizacion = new Date(fecha);
    var tiempoTranscurrido = (fechaActual.getTime() - fechaVisualizacion.getTime()) / 1000;
    var segundosEnUnMinuto = 60;
    var segundosEnUnaHora = 60 * segundosEnUnMinuto;
    var segundosEnUnDia = 24 * segundosEnUnaHora;
    var segundosEnUnaSemana = 7 * segundosEnUnDia;
    var segundosEnUnMes = 30 * segundosEnUnDia;
    var segundosEnUnAnio = 365 * segundosEnUnDia;
    if (tiempoTranscurrido < segundosEnUnMinuto) {
        return "Hace ".concat(Math.floor(tiempoTranscurrido), " segundos");
    }
    else if (tiempoTranscurrido < segundosEnUnaHora) {
        var minutos = Math.floor(tiempoTranscurrido / segundosEnUnMinuto);
        return "Hace ".concat(minutos, " ").concat(minutos === 1 ? "minuto" : "minutos");
    }
    else if (tiempoTranscurrido < segundosEnUnDia) {
        var horas = Math.floor(tiempoTranscurrido / segundosEnUnaHora);
        return "Hace ".concat(horas, " ").concat(horas === 1 ? "hora" : "horas");
    }
    else if (tiempoTranscurrido < segundosEnUnaSemana) {
        var dias = Math.floor(tiempoTranscurrido / segundosEnUnDia);
        return "".concat(dias === 1 ? "Ayer" : "Hace ".concat(dias, " d\u00EDas"));
    }
    else if (tiempoTranscurrido < segundosEnUnMes) {
        var semanas = Math.floor(tiempoTranscurrido / segundosEnUnaSemana);
        return "Hace ".concat(semanas, " ").concat(semanas === 1 ? "semana" : "semanas");
    }
    else if (tiempoTranscurrido < segundosEnUnAnio) {
        var meses = Math.floor(tiempoTranscurrido / segundosEnUnMes);
        return "Hace ".concat(meses, " ").concat(meses === 1 ? "mes" : "meses");
    }
    else {
        var anios = Math.floor(tiempoTranscurrido / segundosEnUnAnio);
        return "Hace ".concat(anios, " ").concat(anios === 1 ? "año" : "años");
    }
};
export var convertToTimeFormat = function (minutes) {
    minutes = Math.round(minutes);
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = minutes % 60;
    var formattedHours = hours.toString().padStart(2, "0");
    var formattedMinutes = remainingMinutes.toString().padStart(2, "0");
    return "".concat(formattedHours, ":").concat(formattedMinutes);
};
